<template>
  <div id="apt-home">
    <div class="page-header">
      <div class="title">서울 아파트 실거래가</div>
      <div class="subtitle">국토교통부 실거래가 기반 서울시 아파트 시장 동향 대시보드</div>
    </div>

    <!-- 시장 요약 KPI -->
    <AptMarketSummary />

    <!-- 거래량·평균가 추이 -->
    <section class="home-section">
      <h2 class="section-title">거래량 · 평균가 추이</h2>
      <div id="seoul-chart-area">
        <SeoulTradeStat12Month />
        <SeoulTradeStat10Year />
      </div>
    </section>

    <!-- 구별 랭킹 + 최근 거래 -->
    <section class="home-section">
      <h2 class="section-title">자치구 랭킹 · 최근 거래</h2>
      <div id="home-bottom-area">
        <SggAvgAmount />
        <RecentTradeFeed />
      </div>
    </section>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import UtilMixin from "@/common/mixins/UtilMixin";
import SeoulTradeStat12Month from "./chart/SeoulTradeStat12Month.vue";
import SeoulTradeStat10Year from "./chart/SeoulTradeStat10Year.vue";
import SggAvgAmount from "./chart/SggAvgAmount.vue";
import RecentTradeFeed from "./chart/RecentTradeFeed.vue";
import AptMarketSummary from "./chart/AptMarketSummary.vue";

export default defineComponent({
  name: "AptHomeView",
  components: {
    SeoulTradeStat12Month,
    SeoulTradeStat10Year,
    SggAvgAmount,
    RecentTradeFeed,
    AptMarketSummary,
  },
  setup() {
    return {};
  },

  data() {
    return {
      //
    };
  },
  mixins: [UtilMixin],
  computed: {
    //
  },
  methods: {
    //
  },
});
</script>
